import {useAuth} from '../../modules/auth'
import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {renderDashboardDateTwoLine, renderDashboardContact, renderDashboardUserName} from './dashboardFormatters'
import {useVerifyTokenOnClick} from './useVerifyTokenOnClick'

const columns: DashboardColumn<any>[] = [
  {header: 'Name', sortKey: 'first_name', render: (item) => renderDashboardUserName(`${item.first_name ?? ''} ${item.last_name || 'User'}`)},
  {header: 'Email', sortKey: 'email', minWidth: 180, render: (item) => renderDashboardContact('email', item.email)},
  {
    header: 'Mobile Number',
    sortKey: 'mobile_number',
    width: 160,
    render: (item) =>
      renderDashboardContact('phone', item.mobile_number && item.mobile_number !== 'NaN' ? item.mobile_number : 'N/A'),
  },
  {header: 'Created', sortKey: 'created_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.created_at)},
  {header: 'Updated', sortKey: 'updated_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.updated_at)},
]

function TotalAllAdmin() {
  const {currentUser} = useAuth()
  useVerifyTokenOnClick()

  return (
    <DashboardApiTableShow
      endpoint='GetAllAdmin'
      title='Total Admins'
      paginationTitle='Admins'
      userTypeId={currentUser?.roles?.[0]?.id}
      columns={columns}
    />
  )
}

export default TotalAllAdmin
